import { Provider } from "react-redux";
import { store } from "store";

const ReduxStoreProvider = ({ children }) => {
    return <Provider store={store}>{children}</Provider>;
};

export default ReduxStoreProvider;
